import React, { useEffect } from "react";
import styles from "../styles/contact.module.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import facebookIcon from "../assets/face.png";
import twitterIcon from "../assets/twitter.png";
import linkedinIcon from "../assets/link.png";
import instagramIcon from "../assets/insta.png";
import { useLocation } from "react-router-dom";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const iconStyle = {
    height: "24px",
    width: "24px",
    borderRadius: "50%",
    backgroundColor: "#fff",
  };
  return (
    <div>
      <Header />
      <div className={styles.container}>
        <div className={styles.formContainer}>
          <h1 style={{fontSize:'36px', fontWeight:'bold'}} >Arifpay Financial Technologies Share Company </h1>
          <h1>Send us a message</h1>
          <p style={{ color: "black" }}>
            Have a question, suggestion, or just want to learn more
            <span className={styles.mobileBreak}>
              <br />
            </span>
            about our innovative AI-powered hiring solutions? Get in touch!
          </p>

          <form>
            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address:</label>
              <input type="email" id="email" placeholder="example@email.com" />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="name">Name:</label>
              <input type="text" id="name" placeholder="John doe" />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="message">Message:</label>
              <textarea id="message" placeholder="Your message..."></textarea>
            </div>
            <button type="submit" className={styles.submitButton}>
              Submit
            </button>
          </form>
        </div>
      </div>
      <section
        style={{
          paddingRight: "30px",
          paddingTop: "20px",
          paddingLeft: "30px",
        }}
      >
        <div
          className={styles.contactWrapper}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            padding: "40px 20px",
            margin: "20px 0",
            marginLeft: "40px",
          }}
        >
          <div style={{ flex: 1, marginRight: "20px" }}>
            <div className={styles.address}>
              <h3 style={{ marginBottom: "0", fontSize: "1.8em" }}>Address</h3>
              <p style={{ color: "black", fontSize: "1.2em" }}>
                Warka Tower 3rd floor, Bole Sub city, Namibia St,
              </p>
              <p style={{ color: "black", fontSize: "1.2em" }}>
                Addis Ababa, Ethiopia
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: "1.8em", marginBottom: "0" }}>
                Office Hours & Visits
              </h3>
              <p style={{ color: "black", fontSize: "1.2em", marginTop: "0" }}>
                We welcome visits during business hours:
                <strong>
                  <p
                    style={{
                      color: "black",
                      fontSize: "1.2em",
                      marginBottom: "0",
                    }}
                  >
                    Monday-Friday 2:30 AM - 11:30 PM Local Time
                  </p>
                </strong>
                <p style={{ color: "black", fontSize: "1.1em", marginTop: "0" }}>
                  For appointments or meetings, please contact{" "}
                  <span className={styles.mobileBreaks}></span> us in advance.
                </p>
              </p>
              <p style={{ color: "black", fontSize: "1.2em" }}>
                Addis Ababa, Ethiopia
              </p>
            </div>
            <div >
              <h3 style={{ fontSize: "1.5em", marginBottom: "0" }}>Email Us</h3>
              <p style={{ color: "black", fontSize: "1.2em", marginTop: "0" }}>
             info@arifpay.net
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: "1.6em", marginBottom: "0" }}>Call Us</h3>
              <p style={{ color: "black", fontSize: "1.2em" , marginTop:'0'}}>9395</p>
            </div>
            <div>
              <h3 style={{ fontSize: "1.5em" }}>Connect With us</h3>
              <div style={{ display: "flex" }}>
                <a
                  href="https://www.facebook.com/ArifpayET"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "10px" }}
                >
                  <img src={facebookIcon} alt="Facebook" style={iconStyle} />
                </a>
                <a
                  href="https://twitter.com/ArifpayEthiopia"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "10px" }}
                >
                  <img src={twitterIcon} alt="Twitter" style={iconStyle} />
                </a>
                <a
                  href="https://et.linkedin.com/company/arifpay-financial-technologies-s-c"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "10px" }}
                >
                  <img src={linkedinIcon} alt="LinkedIn" style={iconStyle} />
                </a>
                <a
                  href="https://www.instagram.com/arifpayet/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagramIcon} alt="Instagram" style={iconStyle} />
                </a>
              </div>
            </div>
          </div>
          <div
            className={styles.images}
            style={{ flex: 1, marginTop: "100px" }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.702791019915!2d38.781710610735324!3d8.99947168941288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85ba309a753d%3A0x8fe6207c84f3c29d!2sArifpay%20financial%20technologies%20S.C!5e0!3m2!1sen!2set!4v1748701360868!5m2!1sen!2set"
              width="600"
              height="450"
              style={{
                border: 0,
                allowfullscreen: "",
                loading: "lazy",
                referrerpolicy: "no-referrer-when-downgrade",
              }}
            ></iframe>
          </div>
        </div>
      </section>

      {/* <section className={styles.hero}>
        <h1 style={{ fontSize: "2.5em", color: "#333", marginBottom: "15px" }}>
          Subscribe To Our Newsletter
        </h1>
        <p style={{ fontSize: "1.2em", color: "black", marginBottom: "30px" }}>
          Keep in touch for latest updates and resales.
        </p>
        <div className={styles.heroButtons}>
          <div className={styles.formGroup}>
            <input type="email" id="email" placeholder="example@email.com" />
          </div>

          <button type="submit" className={styles.primaryButton}>
            Submit
          </button>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default Contact;
